module.exports = __webpack_public_path__ + "static/img/platform03.892b31b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/platform03.png
// module id = EzMW
// module chunks = 1